module.exports = __webpack_public_path__ + "img/weddings_02_V.6aa51762.webp";